<template>
  <el-dialog title="选择联系人" :visible.sync="visible" v-if="visible" width="30%">
    <div class="content-body">
      <div class="table-class">
        <NewTable :data="tableData" :columns="columns" :pages="null"></NewTable>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="visible = false">取 消</el-button>
  </span>
  </el-dialog>
</template>

<script>
import NewTable from "@/components/new-table"

export default {
  components: {NewTable},
  data() {
    return {
      visible: false,
      tableData: [],
      columns: [
        {label: "联系人", prop: "linkName"},
        {label: "联系电话", prop: "linkPhone"},
        { label: '操作',
          render: ( h,{ row } ) => {
            return <span class="operatorCss" onClick={ () => this.selectLinker(row) }>选择</span>
          }
        }
      ],
    }
  },
  methods: {
    open(data) {
      this.tableData = data;
      this.visible = true;
    },
    selectLinker(row) {
      this.$emit('confirmSelect',row);
      this.visible = false;
    }
  }
}
</script>

<style scoped lang="scss">
.content-body {
  display: flex;
  flex-direction: column;
  height: 300px;
  .table-class {
    margin-top: 20px;
    flex: 1;
    display: flex;
    ::v-deep .operatorCss {
      color: #409Eff;
      cursor: pointer;
    }
  }
}
</style>
